import { Directive, HostListener, ElementRef, Input, OnChanges, SimpleChanges, Renderer2, OnInit } from '@angular/core';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[waiting-spinner]' })
export class WaitingSpinnerDirective implements OnChanges {

  @Input()
  isWaiting = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateStatus();
  }

  private updateStatus() {
    if (this.isWaiting) {
      this.elementRef.nativeElement.disabled = true;
      this.renderer.addClass(this.elementRef.nativeElement, 'waiting');

    } else {
      this.elementRef.nativeElement.disabled = false;
      this.renderer.removeClass(this.elementRef.nativeElement, 'waiting');
    }
  }

}




// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/directives/waiting-spinner/waiting-spinner.directive.ts